<script src="list.ts"></script>
<page-content>
  <header-elitment header
                   [hasSideMenu]="true"></header-elitment>
  <side-menu left-menu>
    <libraries-side-menu></libraries-side-menu>
  </side-menu>
  <error-401 *ngIf="is401"></error-401>
  <error-404 *ngIf="is404"></error-404>
  <module-content *ngIf="!is401 && !is404"
                  [title]="pageTitle"
                  [mainActions]="mainActions">

    <div class="search-bar">
      <mat-form-field
        class=""
        color="primary">
        <input #search
               matInput
               type="text"
               maxlength="255"
               placeholder="{{ 'Filter' | translate }}">
        <mat-icon class="search-icon" (click)="triggerSearch()" matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <mat-table *ngIf="!isLoading" [dataSource]="dataSource">
      <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columns"></mat-row>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef class="name-cell flex-2">{{ 'Name' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="name-cell flex-2">
          <div *ngIf="row.rights.view; else notLink">
            <a (click)="onRowClicked(row)">{{ row.name }}</a>
          </div>
          <ng-template #notLink>
            <div>{{ row.name }}</div>
          </ng-template>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="adn">
        <mat-header-cell *matHeaderCellDef class="name-cell flex-3-1">{{ 'Adn' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="name-cell flex-3-1">
          <div *ngIf="row.adn !== null && row.histogramData !== null" class="adn">

            <table-histogram-chart
              [showOnlyBar]="true"
              [rows]="row.histogramData.rows"
              [columns]="row.histogramData.cols"
              [values]="row.histogramData.values">
            </table-histogram-chart>

          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalTime">
        <mat-header-cell *matHeaderCellDef class="duration-cell hideable-500">{{ 'Time' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="duration-cell hideable-500">
          <div>{{ row.totalTime | durationVerbose:'seconds' }}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tags">
        <mat-header-cell *matHeaderCellDef class="accents-cell">{{ 'Tags' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="accents-cell">
          <span>{{ row.tags }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="creater">
        <mat-header-cell *matHeaderCellDef class="name-cell hideable-500 flex-1">{{ 'Created_by' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="name-cell hideable-500 flex-1">
          {{ row.creater?.firstName + ' ' + row.creater?.lastName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="special-actions-cell"></mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="special-actions-cell">
          <button *ngIf="row.rights.duplicate || row.rights.edit || row.rights.delete"
                  mat-icon-button
                  [matMenuTriggerFor]="rowMoreMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #rowMoreMenu="matMenu" class="action" xPosition="before">
            <button mat-menu-item
                    *ngIf="row.rights.duplicate"
                    (click)="onDuplicateSessionClicked(row)">
              <mat-icon>filter_none</mat-icon>&nbsp;{{ 'Duplicate' | translate }}
            </button>
            <button mat-menu-item
                    *ngIf="row.rights.edit"
                    (click)="onEditSessionClicked(row)">
              <mat-icon>edit_outlined</mat-icon>&nbsp;{{ 'Edit' | translate }}
            </button>
            <button mat-menu-item
                    *ngIf="row.rights.delete"
                    (click)="onDeleteSessionClicked(row)">
              <mat-icon>delete_outlined</mat-icon>&nbsp;{{ 'Delete' | translate }}
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>
    </mat-table>
    <center-loader class="paginator-data-placeholder" *ngIf="isLoading"></center-loader>
    <mat-paginator #paginator
                   hidePageSize
                   [pageSize]="sessionDataSource.itemsPerPage"
                   [length]="sessionDataSource.totalItems"
                   showFirstLastButtons>
    </mat-paginator>

    <div *ngIf="sessionDataSource.totalItems === 0" class="legend">{{ 'No_session_yet' | translate }}</div>
  </module-content>
</page-content>
